module.exports = __webpack_public_path__ + "img/icon_box_blue.015ff3c1.png";